import React from 'react';
import {connect} from 'react-redux';
import {push} from 'react-router-redux';
import {CATEGORY_QRY} from '../../common/constants';
import {trackCategoryChange} from '../../actions/common/gaActions';
import {updateStoreDataAvailability} from "../../actions/store/storeActions";
import styles from "../../css/store/storeCategories.less";

class StoreCategoryItem extends React.Component {
    onCategorySelected = () => {
        this.props.changeCategory(this.props.category.key, this.props.category.title,
            this.props.staticData, this.props.itemsList, this.props.activeOrder);
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    };

    render() {
        return (
            <div className="category-wrapper">
                <span className={"category"+(this.props.category.selected?" selected":"")} name="category" onClick={this.onCategorySelected} key={this.props.category.key}>{this.props.category.title}</span>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    const status = (state.orderStatus || {});
    const staticData = (state.staticData || {});
    return {
        itemsList: state.itemsList,
        activeOrder: status.activeOrder,
        staticData: staticData,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changeCategory: (key, name, staticData, itemsList, activeOrder) => {
            dispatch(trackCategoryChange(name));
            if (staticData.updateItemsAvailabilityOnCategoryChange) {
                dispatch(updateStoreDataAvailability(staticData, key, itemsList, activeOrder));
            }
            dispatch(push(location.pathname+CATEGORY_QRY+"="+key));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(StoreCategoryItem);


// WEBPACK FOOTER //
// ./src/containers/store/StoreCategoryItem.js